import { render, staticRenderFns } from "./AddAssigneeConfig.vue?vue&type=template&id=0515be52&scoped=true"
import script from "./AddAssigneeConfig.vue?vue&type=script&lang=js"
export * from "./AddAssigneeConfig.vue?vue&type=script&lang=js"
import style0 from "./AddAssigneeConfig.vue?vue&type=style&index=0&id=0515be52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0515be52",
  null
  
)

export default component.exports